// This file is auto-generated by scripts/generate-build-info.js. Do not edit.
export const BUILD_COMMIT_HASH = '4d2713c';
